// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const YAxisLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="YAxisLeftIcon" ref={forwardedRef} {...props}>
      <path d="M15.5 3v1.5H17V3z" />
      <path d="M4.5 3v14H3.75a1 1 0 0 1-1-1V3z" />
      <path d="M6.251 15.5h1.5V17h-1.5z" />
      <path d="M10.75 15.5h-1.5V17h1.5z" />
      <path d="M12.5 15.5H14V17h-1.5z" />
      <path d="M17 15.5h-1.5V17H16a1 1 0 0 0 1-1z" />
      <path d="M15.5 13.749v-1.5H17v1.5z" />
      <path d="M15.5 9.25v1.5H17v-1.5z" />
      <path d="M15.5 7.5V6H17v1.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const YAxisLeftIcon = /* @__PURE__ */ Object.assign(
  YAxisLeftIconComponent,
  { displayName: 'YAxisLeftIcon' },
);
